import './SignUp.css';
import { useAuth0 } from '@auth0/auth0-react';
import wagerwizlogonew from '../../../assets/wagerwizlogomarch.svg';

export const SignUp = (props) => {
	const { loginWithRedirect } = useAuth0();

	return (
		<div style={{ height: '100%' }}>
			<main style={{ height: '100%' }} class="main-content landing">
				<div class="signup-container">
					<h1 class="title">Create a free account</h1>
					<p class="subtitle">Creating your account is free and easy. No credit card required.</p>

					<div
						onClick={() =>
							loginWithRedirect({
								authorizationParams: {
									// prompt: 'sign select_account',
									screen_hint: 'signup',
								},
							})
						}
						style={{ backgroundColor: '#282b58', color: 'white' }}
						class="btn signup">
						{/* <svg class="google-icon" viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg">
							<path d="M17.64 9.2c0-.637-.057-1.251-.164-1.84H9v3.481h4.844c-.209 1.125-.843 2.078-1.796 2.717v2.258h2.908c1.702-1.567 2.684-3.874 2.684-6.615z" fill="#4285f4" />
							<path
								d="M9 18c2.43 0 4.467-.806 5.956-2.184l-2.908-2.258c-.806.54-1.837.86-3.048.86-2.344 0-4.328-1.584-5.036-3.711H.957v2.332C2.438 15.983 5.482 18 9 18z"
								fill="#34a853"
							/>
							<path d="M3.964 10.707c-.18-.54-.282-1.117-.282-1.707s.102-1.167.282-1.707V4.961H.957C.347 6.175 0 7.548 0 9s.348 2.825.957 4.039l3.007-2.332z" fill="#fbbc05" />
							<path
								d="M9 3.58c1.321 0 2.508.454 3.44 1.345l2.582-2.58C13.463.891 11.426 0 9 0 5.482 0 2.438 2.017.957 4.961L3.964 7.293C4.672 5.166 6.656 3.58 9 3.58z"
								fill="#ea4335"
							/>
						</svg> */}
						<img style={{ marginRight: 20 }} src={wagerwizlogonew} alt="wagerwiz logo" />
						Sign up to WagerWiz!
					</div>

					<div style={{ justifyContent: 'center' }} class="footer-text flex flex-row">
						Already have a WagerWiz account?
						<div onClick={() => {
							loginWithRedirect({
								authorizationParams: {
									prompt: 'sign select_account',
									// screen_hint: 'signup',
								},
							})
						}} class="footer-link cursor-pointer">
							Login
						</div>
					</div>
				</div>
			</main>
		</div>
	);
};
